import React from 'react';

const Link = ({linkText, linkUrl}) => (<a href={linkUrl} target="_blank">{linkText}</a>);
export default Link;